import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 복지포인트 임시 저장 문서 리스트 
 * @param {*} body 
 * @returns 
 */

const wpTemporaryDocList =(body)=>{
    return customAxios.post(myIpAddress+'/wp/tempList', body ); 
}
export default wpTemporaryDocList;
